import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { SERVICES } from "@/lib/site";
import useSEO from "@/hooks/useSEO";

export default function Services() {
  useSEO({
    title: "Services · Signs, Wraps, Window & Wall Graphics",
    description: "Five integrated service lines — architectural wraps, custom signs, window graphics & frosted film, wall & floor graphics, and professional vinyl installation across Toronto and the GTA.",
    path: "/services",
  });
  return (
    <>
      <section className="pt-36 pb-20 bg-ink-950 border-b border-white/5" data-testid="services-hero">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="eyebrow gold-bar">Services</div>
          <h1 className="font-display text-5xl md:text-7xl mt-5 tracking-tight max-w-4xl">Everything we make, install &amp; transform.</h1>
          <p className="text-white/60 max-w-2xl mt-6 text-lg">Five integrated service lines, one accountable team. Production, installation, and surface prep all in-house.</p>
        </div>
      </section>

      <section className="py-20 bg-ink-950">
        <div className="max-w-7xl mx-auto px-6 md:px-10 space-y-20">
          {SERVICES.map((s, i) => (
            <div key={s.slug} className={`grid grid-cols-1 lg:grid-cols-12 gap-10 items-center ${i%2===1 ? "lg:[&>*:first-child]:order-2" : ""}`} data-testid={`services-item-${s.slug}`}>
              <div className="lg:col-span-7 relative aspect-[4/3] overflow-hidden">
                <img src={s.image} alt={`${s.title} — ${s.short} · Toronto Custom Signs & Wraps`} loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
                <div className="absolute bottom-4 left-4 bg-black/70 px-3 py-1 text-[11px] uppercase tracking-[0.2em] text-gold">0{i+1}</div>
              </div>
              <div className="lg:col-span-5">
                <div className="eyebrow">{s.short}</div>
                <h2 className="font-display text-4xl md:text-5xl mt-4 tracking-tight">{s.title}</h2>
                <p className="text-white/65 mt-5 leading-relaxed">{s.intro}</p>
                <ul className="mt-6 grid grid-cols-2 gap-y-2 gap-x-4">
                  {s.includes.map(item => (
                    <li key={item} className="flex items-center gap-2 text-sm text-white/70"><Check size={13} className="text-gold"/>{item}</li>
                  ))}
                </ul>
                <Link to={`/services/${s.slug}`} className="btn-gold mt-8 inline-flex" data-testid={`services-cta-${s.slug}`}>View details <ArrowUpRight size={14}/></Link>
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
